import {Action, ActionReducerMap, createFeatureSelector, createSelector} from '@ngrx/store';
import {
    PAGE_STATE_RESET,
    PageStateResetAction,
    TOGGEL_INFO_KATEGORIE_ACTION, TOGGLE_ROLLE,
    ToggleInfoKategorieAction, ToggleRolleAction
} from './veranstaltung-home.actions.ui';
import { APP_RESET_ACTION } from '@orga-app/appstart/actions';
import {getVeranstaltungDeckblatt} from '../../app-state/app-state.reducer';
import {FunktionsbereichRolleBenutzerListeUi, InfoKategorieUi} from './veranstaltung-home.model.ui';
import {FunktionsbereichRolleBenutzerListe, InfoKategorie, VeranstaltungDetail} from '../../../../clients/veranstaltungen';


export interface ModuleState {
    page: PageState;
}

export const reducers: ActionReducerMap<ModuleState> = {
    page: pageReducer
};

export interface PageState {
    activeInfoKategorien: Array<string>;
    activeRollen: Array<string>;
}

export const initialPageState: PageState = {
    activeInfoKategorien: [],
    activeRollen: []
};

export function pageReducer(state = initialPageState, action: Action): PageState {
    switch (action.type) {
        // APP RESET
        case APP_RESET_ACTION: {
            return Object.assign({}, state, <PageState>initialPageState);
        }

        // Page State Reset
        case PAGE_STATE_RESET: {
            const a = <PageStateResetAction>action;

            return Object.assign({}, state, <PageState>initialPageState);
        }

        case TOGGEL_INFO_KATEGORIE_ACTION: {
            const a = <ToggleInfoKategorieAction>action;

            let res = [...state.activeInfoKategorien];
            if (res.includes(a.infoKategorieId)){
                res = res.filter((x) => x !== a.infoKategorieId);
            } else {
                res.push(a.infoKategorieId);
            }

            return Object.assign({}, state, {activeInfoKategorien: res});
        }

        case TOGGLE_ROLLE: {
            const a = <ToggleRolleAction>action;

            let res = [...state.activeRollen];
            if (res.includes(a.rolleId)){
                res = res.filter((x) => x !== a.rolleId);
            } else {
                res.push(a.rolleId);
            }

            return Object.assign({}, state, {activeRollen: res});
        }

        default: {
            return state;
        }
    }
}


export const getModuleState = createFeatureSelector<ModuleState>('VeranstaltungHomePage');
export const getPageState = createSelector(getModuleState, (state: ModuleState) => state.page);

// DATA
export const getInfoKategorien = createSelector(getPageState, getVeranstaltungDeckblatt, (state: PageState, veranstaltungDetail: VeranstaltungDetail) => {
    if (veranstaltungDetail == null) {
        return null;
    }
    return veranstaltungDetail.info_kategorien.map((infoKategorie: InfoKategorie) => <InfoKategorieUi>Object.assign({}, infoKategorie, {
        open: state.activeInfoKategorien.includes(infoKategorie.kategorie_id)
    }));
});

export const getFunktionsbereicheRollenListe  = createSelector(getPageState, getVeranstaltungDeckblatt, (state: PageState, veranstaltungDeckblatt: VeranstaltungDetail) => {
    if (veranstaltungDeckblatt === null || veranstaltungDeckblatt.home_rollen_benutzer === undefined || veranstaltungDeckblatt.home_rollen_benutzer === null) {
        return [];
    }

    return veranstaltungDeckblatt.home_rollen_benutzer.map((fbRolleBenutzer: FunktionsbereichRolleBenutzerListe) => <FunktionsbereichRolleBenutzerListeUi>Object.assign({}, fbRolleBenutzer, {
        open: state.activeRollen.includes(fbRolleBenutzer.rolle.rolle_id)
    }));
});



